import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: { token: localStorage.getItem("loggedInUser") },
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken, logo, isEmbed, embededToken } = action.payload;
      if (accessToken !== undefined) state.token = accessToken;
      if (logo !== undefined) state.logo = logo;
      if (isEmbed !== undefined) state.isEmbed = isEmbed;
      if (embededToken !== undefined) state.embededToken = embededToken;
    },
    logOut: (state, action) => {
      state.token = null;
      state.logo = null;
      // localStorage.removeItem("loggedInUser");
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;
export default authSlice.reducer;
export const selectCurrentToken = (state) => state.auth.token;
export const selectCurrentLogo = (state) => state.auth.logo;
export const selectIsEmbed = (state) => state.auth.isEmbed;
export const selectEmbededToken = (state) => state.auth.embededToken;
